import React from "react";
import UserHeader from "../UserHeader";
import ListingHeader from "../ListingHeader";
import { useStyles } from "./style";
import { Box } from "@material-ui/core";
import { Helmet } from "react-helmet";

const ListingLayout = ({
  item,
  title,
  redirect,
  // Content
  children,
  // Button
  hasFilter,
  hasDateFilter,
  hasSorting,
  hasAddTitle,
  addTitle,
  // Button Icon
  hideAdd,
  // Button Actions
  onFilterAction,
  onDateFilter,
  onFilterSorting,
  // Location Toggler
  showLocationToggle,
  // Add Modal
  isAddModal,
  onAddModal,
  //
  paths,
  showProfileTabs,
  profileLocation,
  //
  hasListFilter,
  listfilter,
  onListFilterClick,
  activeListFilter,
  stats,
  hasCount,
  hasCardActions,
  onCardAction,
  cardActionTitle,
  hideOrder,
  showInfoText,
  infoText,
  hasLargeContent,
  hasMediumContent,
  hasFullContent,
  hasYear,
  year,
  onYear,
  yearList,
  hasViewToggle,
  showTimeline,
  onViewChange,
  hasTaskToggle,
  onTaskToggle,
  taskToggle,
  hideHeader,
  hasCsvmodal,
  onCsvAction,
  onLocationChange,
  customContent,
  taskToggleLabel,
  showSearch,
  actionContent,
  showWelcomeMessage,
  isDashboard,
  customTitleContent,
}) => {
  const classes = useStyles();

  const getContentClasses = () => {
    let renderedClasses = `${classes.content}`;
    if (hasMediumContent) renderedClasses += ` ${classes.contentMD}`;
    if (hasLargeContent) renderedClasses += ` ${classes.contentLG}`;
    if (hasFullContent) renderedClasses += ` ${classes.contentFull}`;
    return renderedClasses;
  };

  const getContentWrapperClasses = () => {
    let renderedClasses = `${classes.contentWrapper}`;
    if (isDashboard) renderedClasses += ` ${classes.contentDashboard}`;
    return renderedClasses;
  };

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Box className={classes.header}>
        <UserHeader
          title={title}
          showLocationToggle={showLocationToggle}
          profileTabs={paths}
          showProfileTabs={showProfileTabs}
          profileLocation={profileLocation}
          onLocationChange={onLocationChange}
          showSearch={showSearch}
          showWelcomeMessage={showWelcomeMessage}
        />
      </Box>
      <Box className={getContentWrapperClasses()}>
        <Box className={getContentClasses()}>
          <ListingHeader
            title={title}
            customTitleContent={customTitleContent}
            redirect={redirect}
            item={item}
            hasFilter={hasFilter}
            hasDateFilter={hasDateFilter}
            hasSorting={hasSorting}
            onFilterAction={onFilterAction}
            onFilterSorting={onFilterSorting}
            onDateFilter={onDateFilter}
            hideAdd={hideAdd}
            isAddModal={isAddModal}
            onAddModal={onAddModal}
            hasAddTitle={hasAddTitle}
            addTitle={addTitle}
            hasListFilter={hasListFilter}
            listfilter={listfilter}
            onListFilterClick={onListFilterClick}
            activeListFilter={activeListFilter}
            stats={stats}
            hasCount={hasCount}
            hasCardActions={hasCardActions}
            onCardAction={onCardAction}
            cardActionTitle={cardActionTitle}
            hideOrder={hideOrder}
            showInfoText={showInfoText}
            infoText={infoText}
            hasYear={hasYear}
            year={year}
            onYear={onYear}
            yearList={yearList}
            hasViewToggle={hasViewToggle}
            showTimeline={showTimeline}
            onViewChange={onViewChange}
            showProfileTabs={showProfileTabs}
            hasTaskToggle={hasTaskToggle}
            onTaskToggle={onTaskToggle}
            taskToggle={taskToggle}
            hideHeader={hideHeader}
            hasCsvmodal={hasCsvmodal}
            onCsvAction={onCsvAction}
            customContent={customContent}
            taskToggleLabel={taskToggleLabel}
            actionContent={actionContent}
          />
          {children}
        </Box>
      </Box>
    </>
  );
};

export default ListingLayout;
